import OfficeOriginTable from "./OfficeOriginTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const OfficeOrigin = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officeorigin_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <OfficeOriginTable /> : ""}</>
  );
};

export default OfficeOrigin;
